'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoxBody = function (_React$Component) {
    (0, _inherits3.default)(BoxBody, _React$Component);

    function BoxBody() {
        (0, _classCallCheck3.default)(this, BoxBody);
        return (0, _possibleConstructorReturn3.default)(this, (BoxBody.__proto__ || (0, _getPrototypeOf2.default)(BoxBody)).apply(this, arguments));
    }

    (0, _createClass3.default)(BoxBody, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);


            className = (0, _classnames2.default)('box-body', className);

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: className }, otherProps),
                children
            );
        }
    }]);
    return BoxBody;
}(_react2.default.Component);

BoxBody.PropTypes = {
    className: _react2.default.PropTypes.string,
    children: _Utils.COMPONENT_CHILDREN
};
exports.default = BoxBody;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYm94L0JvZHkuanN4Il0sIm5hbWVzIjpbIkJveEJvZHkiLCJwcm9wcyIsImNsYXNzTmFtZSIsImNoaWxkcmVuIiwib3RoZXJQcm9wcyIsIlJlYWN0IiwiQ29tcG9uZW50IiwiUHJvcFR5cGVzIiwic3RyaW5nIiwiQ09NUE9ORU5UX0NISUxEUkVOIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0lBRXFCQSxPOzs7Ozs7Ozs7O2lDQU1SO0FBQUEseUJBQ3NDLEtBQUtDLEtBRDNDO0FBQUEsZ0JBQ0FDLFNBREEsVUFDQUEsU0FEQTtBQUFBLGdCQUNXQyxRQURYLFVBQ1dBLFFBRFg7QUFBQSxnQkFDd0JDLFVBRHhCOzs7QUFHTEYsd0JBQVksMEJBQVcsVUFBWCxFQUF1QkEsU0FBdkIsQ0FBWjs7QUFFQSxtQkFDSTtBQUFBO0FBQUEseUNBQUssV0FBV0EsU0FBaEIsSUFBK0JFLFVBQS9CO0FBQ0tEO0FBREwsYUFESjtBQUtIOzs7RUFoQmdDRSxnQkFBTUMsUzs7QUFBdEJOLE8sQ0FDVk8sUyxHQUFZO0FBQ2ZMLGVBQVdHLGdCQUFNRSxTQUFOLENBQWdCQyxNQURaO0FBRWZMLGNBQVVNO0FBRkssQztrQkFERlQsTyIsImZpbGUiOiJCb2R5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjbGFzc05hbWVzIGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHtDT01QT05FTlRfQ0hJTERSRU59IGZyb20gJy4uL1V0aWxzMic7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEJveEJvZHkgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICAgIHN0YXRpYyBQcm9wVHlwZXMgPSB7XG4gICAgICAgIGNsYXNzTmFtZTogUmVhY3QuUHJvcFR5cGVzLnN0cmluZyxcbiAgICAgICAgY2hpbGRyZW46IENPTVBPTkVOVF9DSElMRFJFTlxuICAgIH07XG5cbiAgICByZW5kZXIoKSB7XG4gICAgICAgIGxldCB7Y2xhc3NOYW1lLCBjaGlsZHJlbiwgLi4ub3RoZXJQcm9wc30gPSB0aGlzLnByb3BzO1xuXG4gICAgICAgIGNsYXNzTmFtZSA9IGNsYXNzTmFtZXMoJ2JveC1ib2R5JywgY2xhc3NOYW1lKTtcblxuICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9e2NsYXNzTmFtZX0gey4uLm90aGVyUHJvcHN9PlxuICAgICAgICAgICAgICAgIHtjaGlsZHJlbn1cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICApO1xuICAgIH1cbn1cblxuIl19